import moment from 'moment'

export const convertDateToUTC = date =>
    new Date(
        date.getUTCFullYear(), 
        date.getUTCMonth(), 
        date.getUTCDate(), 
        date.getUTCHours(), 
        date.getUTCMinutes(), 
        date.getUTCSeconds()
    )

export const adjustDate = date => {
    return moment(date).toDate()
}

export const justDate = date => {
    return moment(date).format('MM/DD/YYYY')
}
